<div class="bg-m1 flex h-full items-center justify-center">
  <div class="flex flex-col items-center">
    <div>
      <m-completed-ring></m-completed-ring>
    </div>

    <div
      data-cy="projectDeletedTitle"
      class="text-s2 mt-5 select-none text-2xl font-semibold"
      >{{ pageTitle }}</div
    >
    <div class="text-s1 mt-5 text-center text-base font-semibold">{{
      projectName
    }}</div>

    <div class="text-s1 mt-5 text-center text-base"
      >Choose another project or create a new one</div
    >
  </div>
</div>
